<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>姓_英字</th>
          <th>名_英字</th>
          <th>ミドルネーム 英字</th>
          <th>性別</th>
          <th>生年月日</th>
          <th>国コード</th>
          <th>都道府県コード</th>
          <th>ニックネーム</th>
          <th>登録日時</th>
          <th>更新日時</th>
        </tr>
        <tr v-for="(user, index) in this.users" :key="index">
          <td>{{ user.id }}</td>
          <td>{{ user.lastNameEn }}</td>
          <td>{{ user.firstNameEn }}</td>
          <td>{{ user.middleNameEn }}</td>
          <td>{{ user.sex }}</td>
          <td>{{ user.birthday }}</td>
          <td>{{ user.countryCode }}</td>
          <td>{{ user.prefCode }}</td>
          <td>{{ user.nickname }}</td>
          <td>{{ user.createdAt }}</td>
          <td>{{ user.updatedAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import firebase from "firebase";
import utils from "@/utils/Utils";

export default {
  name: "usersInfo",
  mixins: [utils, master],
  data() {
    return {
      loading: false,
      db: firebase.firestore(),
      users: [],
    };
  },
  props: {
    firstDate: {
      type: Date,
      required: true,
    },
    lastDate: {
      type: Date,
      required: true,
    },
  },
  created: function() {
    this.loading = true;
    this.db
      .collection("users")
      .orderBy("created_at", "asc")
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          if (doc.exists) {
            var data = doc.data();
            if (data.phone !== undefined) {
              var item = {
                id: doc.id,
                lastNameEn: this.escapeNull(data.last_name_en),
                firstNameEn: this.escapeNull(data.first_name_en),
                middleNameEn: this.escapeNull(data.middle_name_en),
                sex: this.escapeNull(data.sex),
                countryCode: this.escapeNull(data.country_code),
                prefCode: this.escapeNull(data.pref_code),
                nickname: this.escapeNull(data.nickname),
                createdAt: this.formatDateTime(data.created_at.toDate()),
                updatedAt: this.formatDateTime(data.updated_at.toDate()),
              };
              if (data.birthday !== undefined) {
                item.birthday = this.formatDateTime(data.birthday.toDate());
              }
              this.users.push(item);
            }
          }
        });
      })
      .then(() => {
        this.loading = false;
        this.$emit(
          "bind-event",
          this.users,
          this.tsvFormat.userInfo.fileName,
          this.tsvFormat.userInfo.labels
        );
      });
  },
};
</script>
